export default "__VITE_ASSET__DmBlGpmn__"